import { PlusIcon } from '@heroicons/react/24/outline'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ReactElement } from 'react'
import { AddPipeline } from '../pipelines/AddPipeline'
import { closeModal, showModal } from 'app/lib/modal'
import { notifyError, notifySuccess } from 'app/services/notify.client'
import { titleCase } from 'app/utils/titleCase'
import { debug } from 'lib/logging'
import { usePipelineStore } from 'app/stores/StoreContext'

export function NewPipeline({ onPipelineCreated }: { onPipelineCreated: () => void }): ReactElement {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const pipelineStore = usePipelineStore()
  const createPipeline = async (data: { [k: string]: FormDataEntryValue }) => {
    const result = await pipelineStore.create({
      name: data.name as string,
      stages:
        data.stage && data.color ? [{ name: data.stage as string, color: data.color as string, order: 1 }] : undefined,
    })
    if (result.error) {
      debug(`pipeline`, `error`, result.error.message)
      notifyError(
        `There was an error creating your pipeline: ${titleCase(String(data.name))}. ${result.error.message}`,
        `pipeline-create-error`,
      )
    } else {
      const pipeline = pipelineStore.current
      notifySuccess(`Pipeline saved successfully`, `pipeline-create`)
      closeModal()
      window.FS?.(`trackEvent`, { name: `pipelines` })
      if (pipeline) {
        navigate(`/pipelines?tab=${pipeline.id}${searchParams.has(`wId`) ? `&wId=${searchParams.get(`wId`)}` : ``}`)
      }
      onPipelineCreated()
    }
  }
  const handleClick = () => {
    showModal(<AddPipeline createPipeline={createPipeline} />, {
      title: `Create New Pipeline`,
      isFullScreen: false,
      removePadding: true,
      useRadix: true,
    })
  }
  return (
    <button
      type="button"
      className="flex h-9 items-center gap-x-2 pl-1.5"
      onClick={(evt) => {
        evt.preventDefault()
        evt.stopPropagation()
        handleClick()
      }}
    >
      <div className="flex h-9 w-9 items-center justify-center">
        <PlusIcon className="aspect-square h-4 stroke-2 text-subtle" aria-hidden="true" />
      </div>
      <span className="text-label-sm text-subtle">New Pipeline</span>
    </button>
  )
}
